import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";

import { countDown, getCompleteDate } from "../../../utils/util";

import "./auctionExpirationStyles.css";

const AuctionExpiration = ({ target, hasStarted }) => {
  const [time, setTime] = useState({
    second: null,
    minute: null,
    hour: null,
    day: null,
  });

  const date = new Date(target);

  useEffect(() => {
    let timer = setTimeout(() => {
      setTime(countDown(target, true));
    }, 1000);

    return () => {
      clearTimeout(timer);
    };
  });

  return (
    <div className="auction-expiration-countdown w-100">
      <Container className="countdown">
        <Row className="justify-content-center">
          <span className="title text-center mb-2">
            {target === 0
              ? `The Countdown Will Show Once You Start The Auction`
              : `Auction ${hasStarted ? "ends" : "starts"} ${getCompleteDate(
                  date
                )}`}
          </span>
        </Row>
        <Row className="justify-content-center">
          <Col xs={3}>
            <Row
              className={`justify-content-center time-block ${
                target === 0 ? "turn-off" : "turn-on"
              }`}
            >
              <span>{time.day}</span>
            </Row>
            <Row className="justify-content-center">
              <span className="label">Days</span>
            </Row>
          </Col>
          <Col xs={3}>
            <Row
              className={`justify-content-center time-block ${
                target === 0 ? "turn-off" : "turn-on"
              }`}
            >
              <span>{time.hour}</span>
            </Row>
            <Row className="justify-content-center">
              <span className="label">Hours</span>
            </Row>
          </Col>
          <Col xs={3}>
            <Row
              className={`justify-content-center time-block ${
                target === 0 ? "turn-off" : "turn-on"
              }`}
            >
              <span>{time.minute}</span>
            </Row>
            <Row className="justify-content-center">
              <span className="label">Minutes</span>
            </Row>
          </Col>
          <Col xs={3}>
            <Row
              className={`justify-content-center time-block ${
                target === 0 ? "turn-off" : "turn-on"
              }`}
            >
              <span>{time.second}</span>
            </Row>
            <Row className="justify-content-center">
              <span className="label">Seconds</span>
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AuctionExpiration;
